// CORE
import { FormsModule } from '@angular/forms';
import { NgModule } from "@angular/core";

// HELPERS
import { DateStrFormat, FirstCharacter } from './string-utils';
import { EditingBorderDirective } from './directives/editing-border.directive';
import { IsEllipsisActiveDirective } from './directives/is-ellipsis-active.directive';
import { HistorialHelper } from './historial-utils';


const HELPERS = [
  DateStrFormat,
  EditingBorderDirective,
  FirstCharacter,
  IsEllipsisActiveDirective,
]

@NgModule({
  declarations: HELPERS,
  imports: [FormsModule],
  providers: [HistorialHelper],
  exports: HELPERS
})

export class HelpersModule { }
